import axios from "axios";

const base_url = process.env.VUE_APP_BASE_API;

console.log('Environment: ', process.env.NODE_ENV);
console.log('EndPoint: ', base_url);
console.log('Version: ', process.env.VUE_APP_VERSION);

const APIAccount = axios.create({
    baseURL: base_url + "/api",
});

const APIGec = axios.create({
    baseURL: base_url + "/api/gec/v1/",
});

const APIGed = axios.create({
    baseURL: base_url + "/api/ged/v1/",
});

const APISettings = axios.create({
    baseURL: base_url + "/api/setting/v1/",
});

APIAccount.interceptors.request.use((config) => {
    const token = localStorage.getItem("access");
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
});

APIGec.interceptors.request.use((config) => {
    const token = localStorage.getItem("access");
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
});

APIGed.interceptors.request.use((config) => {
    const token = localStorage.getItem("access");
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
});

APISettings.interceptors.request.use((config) => {
    const token = localStorage.getItem("access");
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
});

export { APIAccount, APIGec, APIGed, APISettings };